import reportAlertIcon from '../../../assets/reportAlertIcon.png';

export default function PostReportSnackbarIcon() {
  return (
    <img src={reportAlertIcon} alt="" />
  );
}